import { render } from "./mobileBurgerMenu.vue?vue&type=template&id=5d846fac&scoped=true"
import script from "./script?vue&type=script&lang=js"
export * from "./script?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=5d846fac&scoped=true&lang=scss"

import exportComponent from "/builds/development-team/front-end/acgnn-sports/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d846fac"]])

export default __exports__